<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="kpi">
	@if (kpi?.label) {
		<div class="title-container">
			@if (color) {
				<div
					class="color"
					[ngStyle]="{ 'background-color': color }"
				>
					<div
						class="pattern"
						[ngClass]="[pattern ? pattern : '']"
						[ngStyle]="{
							'background-image': pattern ? 'url(images/' + pattern + '.svg)' : 'none'
						}"
					></div>
				</div>
			}

			<span class="kpi-title">
				{{ kpi?.label }}
			</span>
		</div>
	}

	<div class="kpi-data">
		<span class="kpi-value-before-comma">
			{{ kpi?.data?.valueBeforeComma || 0 }}
		</span>

		@if (kpi?.data?.valueAfterComma) {
			<span class="kpi-value-after-comma">.{{ kpi?.data?.valueAfterComma }}</span>
		}

		<span class="kpi-unit">
			{{ kpi?.data?.unit }}
		</span>
	</div>
</div>
